import { InputTextField } from "@/components/ui/form/fields/input-field/input-text";

type Props = {
	freeTextSearch: string;
	onSetFreeTextSearch: (freeText: string) => void;
};

export const Filter = ({
	freeTextSearch,
	onSetFreeTextSearch, //
}: Props) => {
	return (
		<div>
			{/* 通常検索セクション */}
			<InputTextField
				className="w-full tablet:w-2/3 laptop:w-1/2"
				value={freeTextSearch}
				handleChange={onSetFreeTextSearch}
				placeholder="名前, 購入商品 etc"
			/>
		</div>
	);
};

Filter.displayName = "Filter";
